"use client";

import React from "react";
import AccordionItemContext from "./context";

const useAccordionItem = () => {
  const context = React.useContext(AccordionItemContext);

  if (!context) {
    throw new Error("useAccordionItem must be inside AccordionItem");
  }

  return context;
};

export default useAccordionItem;
